import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { Loggerservice } from "../../../services/logger-service";

@Component({
  selector: "app-miles-configure",
  templateUrl: "./miles-configure.component.html"
})
export class MilesConfigureComponent implements OnInit {
  actionmode: string = "Seacrh";
  headerDivName: string = "addOrEdit"
  showList: boolean = false;
  screentitle: string = "Miles Configure";
  isedit = false;
  key_id;

  screen_details: any = [];
  previousData: any = [];
  search_details: any = [];
  parent_table = "miles_configure";
  searchlist = false;
  loader = false;
  searchresult = false;
  serachtabledata: any = [];
  constructor(
    private vernostService: VernostServiceService,
    private logService: Loggerservice
  ) {}

  ngOnInit() {}

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
    this.isedit = false;
    document.getElementById("errs").innerHTML = "";
  }

  searchForm() {
    document.getElementById("errs").innerHTML = "";
    
    this.screen_details = [];
    this.search_details =[];
  
    this.isedit = false;
    this.actionmode = "Search";
   
  }

  submitData() {
    var data = {
      from: this.screen_details.from == undefined ? "" :this.screen_details.from,
      to: this.screen_details.to == undefined ? "" :this.screen_details.to,
      trip: this.screen_details.trip == undefined ? "" :this.screen_details.trip,
      fare: this.screen_details.fare == undefined ? "" :this.screen_details.fare,
      cabin: this.screen_details.cabin == undefined ? "" :this.screen_details.cabin,
      redemption: this.screen_details.redemption == undefined ? "" :this.screen_details.redemption,
      multiplier: this.screen_details.multiplier == undefined ? "" :this.screen_details.multiplier,
      id: this.key_id
    };

    var screenInfo = [];


    screenInfo.push(data);
    console.log("--------->",screenInfo,"isedit",this.isedit)
    if (this.isedit) {
      this.vernostService.updateMilesConfigure(data).subscribe(response => {
        if (response[0].mas == "success") {
          document.getElementById("errs").innerHTML =
            "Record Updated Successfully";
            setTimeout(function() {
              document.getElementById("errs").innerHTML = "";
            }, 5000);

          this.logService.create_log_masters(
            "'Component Name':Miles-Configure Master,'Action':Update Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Privious Record':" +
              JSON.stringify(this.previousData) +
              ",'New Record':" +
              JSON.stringify(screenInfo),
            "info"
          );

          //   this.screen_details = [];
        } else {
          document.getElementById("errs").innerHTML = "Failed To Create Record";
          setTimeout(function() {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    } else {
      this.vernostService.submitMilesConfigure(data).subscribe(response => {
        // res.send([{ mas: "success" }]);
        if (response[0].mas == "success") {
          document.getElementById("errs").innerHTML =
            "Record Created Successfully";
            setTimeout(function() {
              document.getElementById("errs").innerHTML = "";
            }, 5000);

          this.logService.create_log_masters(
            "'Component Name':Miles-Configure Master,'Action':Create Record,'Modified by':" +
              localStorage.getItem("fname") +
              ",'Record':" +
              JSON.stringify(screenInfo),
            "info"
          );
          this.screen_details = [];
        } else {
          document.getElementById("errs").innerHTML = "Failed To Create Record";
          setTimeout(function() {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  searchData() {
    this.searchlist = false;
    this.loader = true;

    var field1 = this.search_details.from;
    var field2 = this.search_details.to;
    var field3 = this.search_details.trip;
    var field4 = this.search_details.fare;
    var field5 = this.search_details.cabin;
    var field6 = this.search_details.redemption;
    var field7 = this.search_details.multiplier;

    if (
      (field1 == "" || field1 == undefined || field1 == "0") &&
      (field2 == "" || field2 == undefined) &&
      (field3 == "" || field3 == undefined) &&
      (field4 == "" || field4 == undefined) &&
      (field5 == "" || field5 == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "" && field1 != undefined) {
        searchitem.push(field1);
        searchColumn.push("tpm_from");
      }
      if (field2 != "" && field2 != undefined) {
        searchitem.push(field2);
        searchColumn.push("tpm_to");
      }

      if (field3 != "" && field3 != undefined) {
        searchitem.push(field3);
        searchColumn.push("trip_type");
      }

      if (field4 != "" && field4 != undefined) {
        searchitem.push(field4);
        searchColumn.push("fare_type");
      }

      if (field5 != "" && field5 != undefined) {
        searchitem.push(field5);
        searchColumn.push("cabin_class");
      }

      if (field6 != "" && field6 != undefined) {
        searchitem.push(field5);
        searchColumn.push("redemption_multiplier");
      }

      if (field7 != "" && field7 != undefined) {
        searchitem.push(field5);
        searchColumn.push("cancellation_multiplier");
      }

      console.log(this.parent_table);
      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: [],
        filters: []
      };
      // alert(JSON.stringify(Data))
      this.vernostService.searchRecord(Data).subscribe(response => {
        console.log("response=" + JSON.stringify(response));
        if (response.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = response;
          console.log("resule=" + JSON.stringify(response));
          this.searchresult = true;

          this.logService.create_log_masters(
            "'Component Name':Miles-Configure Master,'Action':Srarch Record,'Modified by':" +
              localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record not found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function() {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  showFormData(data) {
    console.log("data=======>",data)
    this.isedit = true;
    // this.screen_details;
    console.log("this.screen_details;=======>",this.screen_details)
    this.actionmode = "Add";
    this.key_id = data.miles_configure_id;
    console.log("this.this.previousData;=======>",this.previousData)
    this.previousData.push(data);
    this.screen_details = {
      from: data.tpm_from,
      to: data.tpm_to,
      trip: data.trip_type,
      fare: data.fare_type,
      cabin: data.cabin_class,
      redemption: data.redemption_multiplier,
      multiplier: data.cancellation_multiplier
    };
  }
  NumberValidation(eve){
    console.log("eveeee",eve)
    if((eve.charCode >= 48 && eve.charCode <= 57)){
      return true;
    }else{    
      return false
    }
  }
}
